let utils = require('../../../actions/utils');
let redirect = require('../../../actions/redirect');
let footer = require('../../../actions/layout/footer');
let seo = require('../../../actions/seo');
let auth = require('../../../actions/auth');
let analytics = require('../../../actions/analytics');

module.exports = [
    analytics.parseUtmFromQuery,
    utils.set('layout', 'auth'),
    seo.setDashboardMeta('Почта подтверждена', 'Почта подтверждена'),
    utils.set(['page', 'name'], 'alert'),
    utils.set(['auth', 'alert', 'type'], 'emailConfirmed'),
    auth.setComputedFields,
    analytics.pageview,
    analytics.argsValueEvent({ category: 'post_successful_registration', action: 'see' }),
    footer.setCopyrightYear,
    redirect.redirect('/login', 5000)
];



// WEBPACK FOOTER //
// ./signals/pages/auth/confirmed.js